import { IFGameItem } from "@/api/apiRsp/IFGameTypeRsp";
import { IFInitWalletRsp, IFWalletRsp } from "@/api/apiRsp/IFWalletRsp";
import { StoryKey } from "@/api/event/commonStoreKey";
import { GameOriginalBetBack } from "@/api/event/IFCustomStore";
import { IFLimboRecordRsp } from "@/api/proto/IFLimbo";
import { IFMessageRsp } from "@/api/apiRsp/IFMessageRsp";
import { useEffect } from "react";
import { sys } from "@/Core/utils/system";
import { useData } from "@/Core/utils/hooks/useDataCenter";

export const useGlobalCurrentWallet = () => {
  return useData<IFInitWalletRsp>(StoryKey.CurrentCurrencyType);
};
/**切换原创游戏面板 */
export const useChangeGamePanel = () => {
  const [data, setData] = useData<any>(StoryKey.ChangeGamePanel);
  return [data, setData];
};

/**原创游戏投注返回 刷新金额 */
export const useUpdateGlobalOriginalBalance = () => {
  return useData<GameOriginalBetBack>(StoryKey.GameOriginalBetBack);
};

/**原创游戏游戏数据 */
export const useCurrentGameData = () => {
  return useData<IFGameItem>(StoryKey.GameOriginalEnterGameData);
};

/**切换投注表单索引 */
export const useChangeBetTab = (value?) => {
  return useData(StoryKey.ChangeBetTab, value);
};

/**玩家投注数据 */
export const usePleryBets = () => {
  return useData<IFLimboRecordRsp[]>(StoryKey.PlayerBetsKey);
};

/**打开搜索**/
export const useGlobalOpenSearch = () => {
  return useData<boolean>(StoryKey.OpenSearchKey);
};
/**打开通知**/
export const useGlobalOpenNotice = () => {
  return useData<boolean>(StoryKey.OpenNoticeKey);
};

/**全局通知消息列表-用于避免重复请求服务端**/
export const useGlobalNoticeData = () => {
  return useData<IFMessageRsp>(StoryKey.GlobalNoticeKey);
};
/**领取完成刷新奖励**/
export const useGlobalRefreshBonus = () => {
  return useData<boolean>(StoryKey.GlobalRefreshBonus);
};
/**监听转盘刷新 */
export const useChangeSpinPanel = () => {
  const [data, setData] = useData<any>(StoryKey.GlobalRefreshSpin);
  return [data, setData];
};
/**监听转盘刷新 */
export const useResetTimerSpin = () => {
  const [data, setData] = useData<any>(StoryKey.GlobalResetTimerSpin);
  return [data, setData];
};

/**全局多语言配置 */
export const useGlobalLang = () => {
  return useData<string>(
    StoryKey.GlobalLang,
    localStorage.getItem("i18nextLng")
  );
};
/**全局主题配置 */
export const useGlobalTheme = () => {
  const [theme, setTheme] = useData<string>(StoryKey.GlobalTheme, "dark");
  useEffect(() => {
    theme && localStorage.setItem("theme", theme);
  }, [theme]);
  return { theme, setTheme };
};

const getStoredAuthToken = () => localStorage.getItem("authToken") || "";

const isAuthTokenUsable = (authToken?: string) => {
  return Boolean(authToken && authToken.length >= 6);
};

/**全局状态 */
export const useGlobalState = () => {
  const storedAuthToken = getStoredAuthToken();
  const [isLogin, setIsLogin] = useData<boolean>(StoryKey.GlobalLogin, isAuthTokenUsable(storedAuthToken));
  const [token, setToken] = useData<string>(
    StoryKey.GlobalToken,
    storedAuthToken
  );
  const [tokenTime, setTokenTime] = useData<string>(
    StoryKey.GlobalTokenTime,
    localStorage.getItem("tokenTime")
  );

  useEffect(() => {
    if (token && token.length) {
      localStorage.setItem("authToken", token);
    } else {
      localStorage.removeItem("authToken");
    }
    if (!isAuthTokenUsable(token)) {
      setIsLogin(false);
    } else {
      setIsLogin(true);
    }
    sys.token = token || "";
  }, [token]);
  useEffect(() => {
    if (tokenTime && tokenTime.length) {
      localStorage.setItem("tokenTime", tokenTime);
    } else {
      localStorage.removeItem("tokenTime");
    }
  }, [tokenTime]);

  return {
    isLogin,
    setIsLogin,
    token,
    setToken,
    tokenTime,
    setTokenTime,
  };
};

/**mobile左侧菜单开关 */
export const useMobileLeftSiderSwitch = () => {
  return useData<boolean>(StoryKey.GlobalMobileLeftSiderSwitch);
};

/**header高度 */
export const useHeaderHeight = () => {
  return useData<number>(StoryKey.GlobalHeaderHeight);
};

/**刷新弹窗 */
export const useRefreshDialog = () => {
  return useData(StoryKey.GlobalRefreshDialog);
};

export const useGlobalWalletStore = () => {
  return useData<IFWalletRsp>(StoryKey.GlobalWalletAllPlus);
};

/**打开红包雨 */
export const useGlobalOpenRedPack = () => {
  return useData<any>(StoryKey.GlobalOpenRedPack);
};

/**打开钱包**/
export const useGlobalOpenWallet = () => {
  return useData<boolean>(StoryKey.GlobalOpenWallet);
};

/**打开用户中心界面 */
export const useGlobalOpenUserCenter = () => {
  return useData<boolean>(StoryKey.GlobalOpenUserCenter);
};

/**移动端iframe游戏是否打开**/
export const useGlobalMobileGameIframeOpen = () => {
  return useData<boolean>(StoryKey.GlobalMobileGameIframeOpen);
};
